// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-orm-static-field-content[data-v-0d9be703]{min-height:59px}", ""]);
// Exports
module.exports = exports;
